export class TaskStatuses {
  static Pending = Boo.Objects.Enums.TaskStatusEnum.Pending;
  static Locked = Boo.Objects.Enums.TaskStatusEnum.Locked;
  static Complete = Boo.Objects.Enums.TaskStatusEnum.Complete;
  static Deleted = Boo.Objects.Enums.TaskStatusEnum.Deleted;
  static NeedsData = Boo.Objects.Enums.TaskStatusEnum.NeedsData;
  static ReconcileComplete = Boo.Objects.Enums.TaskStatusEnum.ReconcileComplete;
  static UnlockAndUnassign = Boo.Objects.Enums.TaskStatusEnum.UnlockAndUnassign;
  static SaveProgress = Boo.Objects.Enums.TaskStatusEnum.SaveProgress;
  static ScheduledForDelete = Boo.Objects.Enums.TaskStatusEnum.ScheduledForDelete;
}